// Remembers the ad/campaign a visitor arrived from (30 days) so quote requests can be credited to it.
const KEY = "pgdr_utm";
const TTL = 30 * 24 * 3600 * 1000;
const FIELDS = ["utm_source", "utm_medium", "utm_campaign"];

export function captureUtm() {
  try {
    const q = new URLSearchParams(window.location.search);
    if (!q.get("utm_campaign") && !q.get("utm_source")) return;
    const data = Object.fromEntries(FIELDS.map((f) => [f, (q.get(f) || "").slice(0, 100)]));
    localStorage.setItem(KEY, JSON.stringify({ ...data, at: Date.now() }));
  } catch (_) {
    /* storage blocked */
  }
}

export function getUtm() {
  try {
    const d = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!d || Date.now() - d.at > TTL) return {};
    return Object.fromEntries(FIELDS.filter((f) => d[f]).map((f) => [f, d[f]]));
  } catch (_) {
    return {};
  }
}
